import { UseCase } from '@mdd/api';

export namespace ReplaceParams {
    export interface Params<L extends string> {
        link: L;
        queryParams: object;
    }
}

export class ReplaceParams<L extends string> implements UseCase<ReplaceParams.Params<L>, string> {
    execute({ link, queryParams }: ReplaceParams.Params<L>): string {
        for (const key in queryParams) {
            if (queryParams[key]) {
                link = <L>link.replace(`{${key}}`, queryParams[key]);
            }
        }

        // this is for handling query with optional parameters
        link = link.replace(
            /{&(.*?)}/g,
            (a, b) =>
                b &&
                b
                    .split(',')
                    .map((x) => {
                        if (!queryParams[x]) return;
                        return `&${x}=${queryParams[x]}`;
                    })
                    .join('')
        ) as any;

        return link;
    }
}
